module.exports = __webpack_public_path__ + "img/OurStory_Img2.d64eda48.jpg";